import { render, staticRenderFns } from "./IsgEducations.vue?vue&type=template&id=71e21fee&scoped=true&"
import script from "./IsgEducations.vue?vue&type=script&lang=js&"
export * from "./IsgEducations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e21fee",
  null
  
)

export default component.exports